// http请求相关
import axios from 'axios';
// import Cookies from 'js-cookie';
import store from '../store';
import router from '../router';

const http = axios.create({
    baseURL: process.env.VUE_APP_BASE_API + '/',
    withCredentials: true,
    timeout: 15000,
    headers: {
        showLoading: true
    }
});

// let loading = null;

let notShowError = false;

let responseMsg = '操作失败';

// 请求拦截
http.interceptors.request.use(
    config => {
        // 添加token
        // const token = Cookies.get('pp_token');
        const token = store.state.user.token;
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        // config.headers['Content-Type'] = 'application/json;charset=utf-8';
        if (config.headers.showLoading) {
            // loading = Loading.service({
            //     lock: true
            // });
        }
        if (config.headers.notShowError) {
            notShowError = true;
        }
        if (config.headers.responseMsg) {
            responseMsg = config.headers.responseMsg;
            console.log('responseMsg', responseMsg);
        }
        delete config.headers.showLoading;
        delete config.headers.responseMsg;
        delete config.headers.notShowError;

        return config;
    },
    error => {
        console.error(error);
        return Promise.reject(error);
    }
);

// 响应拦截
http.interceptors.response.use(
    response => {
        // if (loading) {
        //     loading.close();
        // }
        // if (response.status !== 200) {
        //     Message({
        //         message: response.Message || 'Error',
        //         type: 'error',
        //         duration: 5 * 1000,
        //         showClose: true
        //     });
        //     return Promise.reject(new Error(response.Message || 'Error'));
        // }
        const res = response.data;
        const flag = res.flag || (res.hasOwnProperty('code') && res.code === 0);
        if (!flag && !notShowError) {
            // Message({
            //     message: res.msg || responseMsg,
            //     type: 'error',
            //     duration: 3 * 1000,
            //     showClose: true
            // });
            return Promise.reject(new Error(res.msg || '返回code不为0'));
        } else {
            return Promise.resolve(res);
        }
    },
    error => {
        // if (loading) {
        //     loading.close();
        // }
        let msg = error.message;
        if (msg && msg.search('Network Error') >= 0) {
            msg = '网络错误';
        }
        if (msg && msg.search('timeout') >= 0) {
            msg = '请求超时';
        } else {
            if (error.response && error.response.data && error.response.data.Message) {
                msg = error.response.data.Message;
            }
            if (error.response && error.response.status === 401) {
                msg = store.state.user.token ? '登录信息过期，请重新登录' : '请先完成登录';
                store.dispatch('user/logout');
                router.push('/passport');
            }
        }
        // Message({
        //     message: msg,
        //     type: 'error',
        //     duration: 5 * 1000,
        //     showClose: true
        // });
        return Promise.reject(error);
    }
);

export default http;
